import { DatePicker, Space, Table, message, Spin, Form, Tooltip, Button, Divider } from 'antd';
import dayjs from 'dayjs';
import { FileExcelOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import { useContext, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import APIUtils from '../../api/APIUtils';
import { downloadFiles, trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';
const { RangePicker } = DatePicker;

const EmployeeReferralReport = (props) => {

	//Variable declaration
	const commonContext=useContext(CommonContext);
	const buyerId = commonContext.common.buyerId;
	const columns = [
		{
			title: 'Name',
			dataIndex: 'buyerName',
			key: 'buyerName',
			sorter: (a, b) => a.buyerName.length - b.buyerName.length,
			render: (_, record) => {
				return (
					<>
						<span>{record.buyerName}</span>
					</>
				)
			}
		},
		{
			title: 'Applies',
			dataIndex: 'applies',
			key: 'applies',
			align: 'center',
			sorter: (a, b) => a.applies - b.applies,
		},
		{
			title: 'Quality',
			dataIndex: 'quality',
			key: 'quality',
			align: 'center',
			sorter: (a, b) => a.quality - b.quality,
      render: (_, record) => {
				return (
					<Space size={3}>
						<span>{record.quality}</span><span>({record.qualityPer}%)</span>
					</Space>
				)
			}
		},
		{
			title: 'Interviews',
			dataIndex: 'interview',
			key: 'interview',
			align: 'center',
			sorter: (a, b) => a.interview - b.interview,
      render: (_, record) => {
				return (
					<Space size={3}>
						<span>{record.interview}</span><span>({record.interviewPer}%)</span>
					</Space>
				)
			}
		},
		{
			title: 'Offer',
			dataIndex: 'offer',
			key: 'offer',
			align: 'center',
			sorter: (a, b) => a.offer - b.offer,
      render: (_, record) => {
				return (
					<Space size={3}>
						<span>{record.offer}</span><span>({record.offerPer}%)</span>
					</Space>
				)
			}
		},
		{
			title: 'Hires',
			dataIndex: 'hired',
			key: 'hired',
			align: 'center',
			sorter: (a, b) => a.hired - b.hired,
      render: (_, record) => {
				return (
					<Space size={3}>
						<span>{record.hired}</span><span>({record.hiredPer}%)</span>
					</Space>
				)
			}
		},
	];
	const [employeeReferralData, setEmployeeReferralData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [rangePickerValue, setRangePickerValue] = useState([]);
	const [loader, setLoader] = useState(false);
	const [totalQualityCount, setTotalEmployeeReferralCount] = useState(0);
	const [employeeReferralReportTotal, setEmployeeReferralReportTotal] = useState([]);
	const [referralLink,setReferralLink]=useState('');
	const [form] = Form.useForm();

	useEffect(() => {
		const date1 = dayjs().startOf('month')
		const date2 = dayjs().endOf('month')
		form.setFieldsValue({
			rangePicker: [
				date1,
				date2,
			],
		});
		setRangePickerValue([
			date1.format(constants.MonthFormat),
			date2.format(constants.MonthFormat),
		]);
		GetEmployeeReferralReportData(1, 100,
			date1.format(constants.MonthFormat),
			date2.format(constants.MonthFormat));
		trackPageAccess(buyerId,window.location.href)
	}, []);


	//Functions
	//Function runs when range picker value is changed
	const RangePickerChanged = debounce((_, dateStrings) => {
		//props.changeDate(dateStrings);
		setRangePickerValue([
			dayjs(dateStrings[0], constants.MonthFormat),
			dayjs(dateStrings[1], constants.MonthFormat),
		]);
		GetEmployeeReferralReportData(currentPage, pageSize, dateStrings[0], dateStrings[1]);
	}, 500);

	//Function to employee referral report data
	const GetEmployeeReferralReportData = async (currentPage, pazeSize, startDate, endDate) => {
		setLoader(true);
		const response = await APIUtils.apiCall('GET', WebLinks.GetEmployeeReferralReport + buyerId+ "&fromDate=" + startDate + "&toDate=" + endDate + "&limit=" + pazeSize + "&pageNo=" + currentPage);
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
			setEmployeeReferralReportTotal(response.resultObj.data.pop());
			setEmployeeReferralData(response.resultObj.data);
			// if(response?.resultObj?.data?.length===0){
			// 	message.error(response.resultObj.message);
			// }
			setReferralLink(response.resultObj.companyReferalLink)
			setTotalEmployeeReferralCount(response.resultObj.getCount);
			setLoader(false);
		} else {
			setEmployeeReferralData([]);
      setTotalEmployeeReferralCount(0);
			setLoader(false);
			message.error(response.resultObj.message);
		}
	}

	//Function on change of application table
	const onchangeApplicationTable = (pagination, filters, sorter) => {
		if (pagination) {
			if (pageSize !== pagination.pageSize) {
				setCurrentPage(1);
			} else {
				setCurrentPage(pagination?.current);
			}
			setPageSize(pagination?.pageSize);
			GetEmployeeReferralReportData(pagination?.current, pagination?.pageSize, rangePickerValue[0], rangePickerValue[1])
		}
	};

	//Function to download as excel
	const downloadFile = () => {
		setLoader(true)
		downloadFiles(WebLinks.DownloadEmployeeReferralReport+buyerId + `&fromDate=${dayjs(rangePickerValue[0]).format(constants.MonthFormat)}&toDate=${dayjs(rangePickerValue[1]).format(constants.MonthFormat)}`,"EmployeeReferralReport.xlsx");
		setTimeout(() => {
				setLoader(false)
		}, 3000);
	};

	 //Function to open referral link in new tab
	 const openReferralLink=()=>{
		if(referralLink && referralLink!==""){
			window.open(referralLink,"_blank");
		}else{
			message.error("Referral link not found");
		}
  };

	//Function to display the month total in the table
	const employeeReferralReportSummary = () => {
		return (
			<>
				<Table.Summary.Row className='bg-teal-50'>
					<Table.Summary.Cell index={0} align='center'>
						<strong>Totals</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={1} className='text-center'>
						<strong>{employeeReferralReportTotal?.applies}</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={2} className='text-center'>
            <strong><Space size={3}>{employeeReferralReportTotal?.quality}<span>({employeeReferralReportTotal?.qualityPer}%)</span></Space></strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={3} className='text-center'>
            <strong><Space size={3}>{employeeReferralReportTotal?.interview}<span>({employeeReferralReportTotal?.interviewPer}%)</span></Space></strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={4} className='text-center'>
            <strong><Space size={3}>{employeeReferralReportTotal?.offer}<span>({employeeReferralReportTotal?.offerPer}%)</span></Space></strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={5} className='text-center'>
            <strong><Space size={3}>{employeeReferralReportTotal?.hired}<span>({employeeReferralReportTotal?.hiredPer}%)</span></Space></strong>
					</Table.Summary.Cell>
				</Table.Summary.Row>
			</>
		)
	};

	return (
		<>
			<Spin spinning={loader}>
				<div>
        <div className='uppercase font-bold text-xl'>Employee Referral Report</div>
          <Divider className='mt-2 mb-2'/>
          <div className="flex items-center justify-center mb-1">
            <p className="text-center font-bold">Your employee referral link is here: <Button className='pl-0' type='link' onClick={()=>openReferralLink()}>Click Here</Button></p>
          </div>
					<div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
						<Form form={form}>
							<Form.Item name="rangePicker" className='mb-0'>
								<RangePicker picker="month"
									placeholder={["From", "To"]}
									onChange={RangePickerChanged}
									format={constants.MonthFormat} />
							</Form.Item>
						</Form>				
          <Tooltip placement='right' title="Download as Excel">
              <Button
                  className='bg-green-800 text-white hover:!text-white hover:!border-green-500'
                  icon={<FileExcelOutlined />}
                  onClick={()=>{downloadFile()}}
              >
                Download as Excel
              </Button>
          </Tooltip>
					</div>
					<div className='overflow-x-auto'>
						<Table
							columns={columns}
							dataSource={employeeReferralData}
							scroll={{
								x: 1000,
							}}
							sortDirections={['descend', 'ascend', 'descend']}
							pagination={false}
							summary={() => employeeReferralReportSummary()}
						/>
					</div>
				</div>
			</Spin>
		</>
	);
};

export default EmployeeReferralReport;